import { render, staticRenderFns } from "./ShopStockItems.vue?vue&type=template&id=5ac754f4"
import script from "./ShopStockItems.vue?vue&type=script&lang=js"
export * from "./ShopStockItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac754f4')) {
      api.createRecord('5ac754f4', component.options)
    } else {
      api.reload('5ac754f4', component.options)
    }
    module.hot.accept("./ShopStockItems.vue?vue&type=template&id=5ac754f4", function () {
      api.rerender('5ac754f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopStockItems.vue"
export default component.exports